// client/src/components/pages/LexiStar/StatusBoard/useLexiStarEvents.js
//
// React binding for the LexiStar realtime relay (m2-contracts §2.4): joins the
// caller's tenant room on /tracking (plus the approvals or a trip room when
// asked) and hands each `lexistar:event` for that tenant to `onEvent`.
//
// The tenant comes from AuthContext (req.tenantContext's twin on the client);
// there is no default tenant — until it is known nothing is joined.

import { useEffect, useRef, useState } from 'react';
import { useAuth } from '../../../../context/AuthContext';
import { subscribeLexiStarEvents } from '../../../../services/lexistarStatusBoard';

/**
 * @param {{approvals?:boolean, tripId?:string|null, enabled?:boolean,
 *          onEvent:(evt:Object)=>void}} opts
 * @returns {'connecting'|'live'|'reconnecting'|'offline'} connection status
 */
export default function useLexiStarEvents({
  approvals = false,
  tripId = null,
  enabled = true,
  onEvent,
}) {
  const { tenant } = useAuth();
  const tenantId = tenant?.tenant_id ?? null;
  const [status, setStatus] = useState('connecting');
  const onEventRef = useRef(onEvent);
  onEventRef.current = onEvent;

  useEffect(() => {
    if (!enabled || tenantId === null) {
      setStatus('offline');
      return undefined;
    }
    setStatus('connecting');
    return subscribeLexiStarEvents({
      tenantId,
      approvals,
      tripId,
      onEvent: (evt) => onEventRef.current?.(evt),
      onStatus: setStatus,
    });
  }, [tenantId, approvals, tripId, enabled]);

  return status;
}
